// function to get speed highlight text and mode
const getSpeedText = (summaryText, data) => {
  if (summaryText) {
    return { text: summaryText, mode: "success" };
  } else if (
    !summaryText &&
    data.crashEvent &&
    (data.crashEvent.speedAtImpact ||
      data.crashEvent.deltaV ||
      data.crashEvent.maxMagnitude ||
      data.crashEvent.confidence)
  ) {
    return { text: "Nothing to highlight", mode: "success" };
  } else {
    return { text: "No data available", mode: "default" };
  }
};

// function to get driving events highlight text and mode
const getDrivingEventText = (summaryText, data) => {
  if (summaryText) {
    return { text: summaryText, mode: "success" };
  } else if (
    !summaryText &&
    data &&
    (data.phoneHandlingSeconds ||
      data.hardAccelerationTimes ||
      data.hardBrakingTimes ||
      data.speedingDistance)
  ) {
    return {
      text: "Nothing to highlight",
      mode: "success",
    };
  } else {
    return { text: "No data available", mode: "default" };
  }
};

// function to get road highlight text and mode
const getRoadText = (summaryText, data) => {
  if (summaryText) {
    return { text: summaryText, mode: "success" };
  } else if (
    !summaryText &&
    (_.get(data, 'crashEvent.roadType', null) || _.get(data, 'crashEvent.speedLimit', null))
  ) {
    return { text: "Nothing to highlight", mode: "success" };
  } else {
    return { text: "No data available", mode: "default" };
  }
};

// function to get traffic highlight text and mode
const getTrafficConditionsText = (summaryText, data) => {
  if (summaryText) {
    return { text: summaryText, mode: "success" };
  } else if (!summaryText && _.get(data, 'trafficIncidentData', []).length > 0) {
    return { text: "Nothing to highlight", mode: "success" };
  } else {
    return { text: "No data available", mode: "default" };
  }
};

// function to get weather highlight text and mode
const getWeatherText = (summaryText, data) => {
  if (summaryText) {
    return { text: summaryText, mode: "success" };
  } else if (summaryText && data.weatherData[0]) {
    return { text: "Nothing to highlight", mode: "success" };
  } else {
    return { text: "No data available", mode: "default" };
  }
};

export const getHighlightText = (summaryText, data) => {
  return {
    speedHighlight: getSpeedText(summaryText, data),
    drivingEventsHighlights: getDrivingEventText(summaryText, data),
    roadHighlightText: getRoadText(summaryText, data),
    trafficConditionsHighlightText: getTrafficConditionsText(summaryText, data),
    weatherHighlightText: getWeatherText(summaryText, data),
  };
};
